import { useESimProfiles } from './hooks/useESimProfiles';

import { Suspense } from 'react';
import { SecondaryConfigurableTable } from 'src/common/components/ConfigurableTable/SecondaryConfigurableTable';
import { TextCell } from 'src/common/components/ConfigurableTable/Components/Cells/TextCell';
import { ESimProfileEnabledCell } from './cells/ESimProfileEnabledCell';
import { useESimProfilesTableActions } from './hooks/useESimProfilesTableActions';
import { ESimProfileLoader } from './ESimProfileLoader';
import { ESIM_PROFILES_CONFIGURATION } from './models/eSimProfiles';
import { Routes } from 'src/Routes.constants';
import { StickyLinkCell } from 'src/common/components/ConfigurableTable/Components/Cells/StickyLinkCell';

type ESimProfilesProps = {
  eid: string;
};

export const ESimProfileIccidLinkCell = ({ value }: any) => {
  return (
    <div data-testid="primaryText">
      <StickyLinkCell value={value} to={`${Routes.simInventory}/${value}`} />
    </div>
  );
};

export const ESimProfilesContent = ({ eid }: ESimProfilesProps) => {
  const {
    queryResult: { data },
  } = useESimProfiles({ eid });

  const actions = useESimProfilesTableActions();

  return (
    <SecondaryConfigurableTable
      data-testid={`esims-profile-${eid}`}
      totalNumberOfItems={data.items.length}
      rows={data.items}
      configuration={ESIM_PROFILES_CONFIGURATION}
      disablePagination
      getRowId={(row) => row.iccid}
      cellConfiguration={{
        default: TextCell,
        iccid: ESimProfileIccidLinkCell,
        enabled: ESimProfileEnabledCell,
      }}
      actions={actions}
    />
  );
};

export const ESimProfiles = (props: ESimProfilesProps) => {
  return (
    <Suspense fallback={<ESimProfileLoader />}>
      <ESimProfilesContent {...props} />
    </Suspense>
  );
};
